import { useSuspenseQuery } from '@tanstack/react-query'
import { getDocs } from 'firebase/firestore'

import { configurationHistoryQuery } from './configurationHistoryCollection'

export interface UseConfigurationHistoryOptions {
  regionId: string
  operatingDate?: string
}

export const configurationHistoryQueryOptions = ({ regionId, operatingDate }: UseConfigurationHistoryOptions) => ({
  queryKey: ['configurationHistory', regionId, operatingDate] as const,
  queryFn: async () => {
    const queryRef = configurationHistoryQuery(regionId, operatingDate)
    const snapshot = await getDocs(queryRef)
    return snapshot.docs.map((doc) => doc.data())
  },
  staleTime: 30_000, // 30 seconds - data may change during the evening
  enabled: !!regionId,
})

export const useConfigurationHistory = (options: UseConfigurationHistoryOptions) =>
  useSuspenseQuery(configurationHistoryQueryOptions(options))

export { type ConfigurationHistoryEvent, configurationHistoryQuery } from './configurationHistoryCollection'
